import { render, staticRenderFns } from "./AdminTongji.vue?vue&type=template&id=008662a8&scoped=true&"
import script from "./AdminTongji.vue?vue&type=script&lang=js&"
export * from "./AdminTongji.vue?vue&type=script&lang=js&"
import style0 from "./AdminTongji.vue?vue&type=style&index=0&id=008662a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008662a8",
  null
  
)

export default component.exports